import _slicedToArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import PropTypes from 'prop-types';
import * as React from 'react';
import { DEPRECATED_PROP_MESSAGES } from '../../constants/messages.js';
import { PaginationContext } from './pagination.context.js';
import { deprecatedProp } from '../core/deprecated-prop.js';
import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _object_spread_props(target, source) {
  source = source != null ? source : {};

  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _object_without_properties(source, excluded) {
  if (source == null) return {};

  var target = _object_without_properties_loose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propTypes = {
  /**
  * @deprecated
  * Please use accessibleText prop instead
  * Provide the text that should be used for screen readers.
  */
  visuallyHiddenText: deprecatedProp(PropTypes.string, DEPRECATED_PROP_MESSAGES.accessibleText),

  /**
  * Provide the text that should be used for screen readers.
  */
  accessibleText: PropTypes.string
};
var Pagination = createComponent({
  displayName: 'Pagination',
  root: 'nav',
  propTypes: propTypes,
  requiredStyleKeys: SWAN_STYLE_KEY_MAP.pagination,
  propConfig: {
    derivedProps: function derivedProps() {
      var _React$useState = React.useState(),
          _React$useState2 = _slicedToArray(_React$useState, 2),
          labelId = _React$useState2[0],
          setLabelId = _React$useState2[1];

      return {
        labelId: labelId,
        setLabelId: setLabelId
      };
    },
    processProps: function processProps(_param) {
      var visuallyHiddenText = _param.visuallyHiddenText,
          accessibleText = _param.accessibleText,
          props = _object_without_properties(_param, ["visuallyHiddenText", "accessibleText"]);

      var accessibleNode = accessibleText !== null && accessibleText !== undefined ? accessibleText : visuallyHiddenText;
      return _object_spread_props(_object_spread({
        'aria-label': accessibleNode !== null && accessibleNode !== void 0 ? accessibleNode : undefined
      }, props), {
        role: 'navigation'
      });
    },
    classNames: ['swan-pagination'],
    wrapRoot: function wrapRoot(_props, derivedProps, element) {
      return /*#__PURE__*/React.createElement(PaginationContext.Provider, {
        value: {
          labelId: derivedProps.labelId,
          setLabelId: derivedProps.setLabelId
        }
      }, element);
    }
  }
});
export { Pagination };